// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ArrowRightIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M17.71 11.29l-4-4a1 1 0 10-1.42 1.42l2.3 2.29H7a1 1 0 000 2h7.59l-2.3 2.29a1 1 0 000 1.42 1 1 0 001.42 0l4-4a1 1 0 000-1.42z"/></svg>'} />;

ArrowRightIcon.displayName = 'ArrowRightIcon';

export default ArrowRightIcon;
